<template>
    <div>
      <el-drawer @reload="$reloadHandle"
                 :title="'驳回处理单'" size="30%"
                 :before-close="handleClose"
                 :visible.sync="drawer"
                 direction="rtl"
                 :modal-append-to-body="true"
                 custom-class="demo-drawer"
                 ref="drawer"
      >

        <div class="demo-drawer__content">
          <el-form :model="formData">
            <el-form-item label="驳回原因" :rules="{required: true}">
              <el-input type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="formData.remark"
                        autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
            bottom: 5px; right: 5px;">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
          </div>
        </div>
      </el-drawer>

    </div>
  </template>
  <script>

  import api from "@/api/projectApi";

  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['id','remark'],
    created() {
      console.log('askdfksdfk', this.id)
      this.formData.id = this.id
      this.formData.remark = this.remark
    },
    data() {
      return {
        formData: {
          remark: null,
          id: null,
          type: null,
        },
        drawer: true,
      }
    },
    methods: {
      // 确定
      confirm() {
        this.$validate(this.formData,
          {remark: [{required: true, prop: '驳回原因', maxlength: 100, type: 'string'}]}
        ).then(() => {
          this.$mask.open()
          this.$http({
            url: api.sfBatchSettle.applicationRejectUrl,
            method: 'post',
            data: this.formData
          }).then(res => {
            this.$message.success('操作成功')
            this.visiable = false
            this.$emit('update:visiable', this.visiable)
            this.$emit('goBackIndex')
            this.$mask.close()
          })
        })
        this.$mask.close()
      },


      // confirm() {
      //   this.drawer = false;
      //   this.handleClose()
      // },
      cancelForm() {
        this.visiable = false
        this.$emit('update:visiable', this.visiable)
      },
      handleClose() {
        this.cancelForm()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  </style>
